import { type FC } from 'react';
import ErrorFilterLink from '@/components/UI/ErrorFilterLink/ErrorFilterLink';
import { FilterTypes as filterType } from '@/constants/FilterTypes';
import SyncingActive from '@/components/UI/SyncingActive/SyncingActive.tsx';
import { _notNil } from '@/littledash.ts';

interface FilterConfig {
  categoryValue: string; // 'sync_status' or 'backfill_status'
  categoryIndex: number; // filter category index, usually 2
}

interface BenchlingSyncStatusAsideProps {
  errorCount: number;
  totalErrorCount?: number | null;
  filterConfig: FilterConfig;
  useTableProps: any;
  testId?: string;
  inStudy?: boolean;
}

const BenchlingSyncStatusAside: FC<BenchlingSyncStatusAsideProps> = ({
  errorCount,
  totalErrorCount = null,
  filterConfig,
  useTableProps,
  testId = 'view-errors-link',
  inStudy = false,
}) => {
  const handleViewErrorsClick = (replace: boolean) => {
    const statusFailedFilter = {
      category: {
        name: 'Status',
        value: filterConfig.categoryValue,
        index: filterConfig.categoryIndex,
      },
      operation: {
        name: filterType.eq,
        index: 0,
      },
      option: {
        name: 'Failed',
        value: 'failed',
      },
    };

    if (replace) {
      useTableProps.apiTable.replaceFilters([statusFailedFilter]);
    } else {
      useTableProps.apiTable.addFilter(statusFailedFilter);
    }
  };

  const showTotal = _notNil(totalErrorCount) && totalErrorCount !== errorCount;

  return (
    <div className="flex items-center justify-end">
      {(errorCount > 0 || showTotal) && (
        <div className={inStudy ? 'mr2 pr2' : ''}>
          <ErrorFilterLink
            errorCount={errorCount}
            totalErrorCount={showTotal ? totalErrorCount : null}
            onViewErrorsClick={handleViewErrorsClick}
            testId={testId}
          />
        </div>
      )}
      {inStudy && <SyncingActive />}
    </div>
  );
};

export default BenchlingSyncStatusAside;
